import axios from 'axios'

const ASSIGNMENTS_PATH = '/api/v2/admins/sales/ig-story'
const MEMBERS_PATH = '/api/v2/admins/sales/ig-story-members'

const SalesIgStoryApi = {
  auditQueue: ({ params = {} } = {}) => axios.get(`${ASSIGNMENTS_PATH}/audit-queue`, { params }),
  progress: ({ params = {} } = {}) => axios.get(`${ASSIGNMENTS_PATH}/progress`, { params }),
  exportXlsx: ({ params = {} } = {}) => axios.get(`${ASSIGNMENTS_PATH}/export-xlsx`, { params, responseType: 'blob' }),
  // Loads Current Queue or Archive data; authorization/scoping is enforced by the backend.
  index: ({ params = {} } = {}) => axios.get(ASSIGNMENTS_PATH, { params }),

  // Loads one assignment cycle. Backend scopes normal SA access to their own assignment.
  show: ({ id }) => axios.get(`${ASSIGNMENTS_PATH}/${id}`),

  // Confirms from Detail that the logged-in SA has already uploaded the item to IG Story.
  confirmUploaded: ({ id }) => axios.post(`${ASSIGNMENTS_PATH}/${id}/confirm-uploaded`),

  // Manager detail + Owner-only queue controls.
  saAssignmentDetail: ({ administratorId, params = {} }) =>
    axios.get(`${ASSIGNMENTS_PATH}/sa/${administratorId}/assignments`, { params }),
  fillSaBucket: ({ administratorId }) =>
    axios.post(`${ASSIGNMENTS_PATH}/sa/${administratorId}/fill-bucket`),
  swapSaAssignments: ({ administratorId, assignedAssignmentIds, replacedAssignmentIds }) =>
    axios.post(`${ASSIGNMENTS_PATH}/sa/${administratorId}/swap`, {
      assigned_assignment_ids: assignedAssignmentIds,
      replaced_assignment_ids: replacedAssignmentIds
    }),

  // Legacy/bulk completion endpoint retained for compatibility; Detail is the primary SA workflow.
  markDone: ({ assignmentIds }) => axios.post(`${ASSIGNMENTS_PATH}/mark-done`, {
    assignment_ids: assignmentIds
  }),

  // Downloads filtered recap data for manager/auditor accounts.
  exportCsv: ({ params = {} } = {}) => axios.get(`${ASSIGNMENTS_PATH}/export-csv`, {
    params,
    responseType: 'blob'
  }),

  // Loads central Audit Log entries generated by the IG Story feature.
  auditLogs: ({ params = {} } = {}) => axios.get(`${ASSIGNMENTS_PATH}/audit-logs`, { params }),

  // Loads data-driven assignee/auditor configuration for manager accounts.
  members: () => axios.get(MEMBERS_PATH),

  // Adds an administrator to the IG Story feature without hardcoded identifiers.
  createMember: ({ payload }) => axios.post(MEMBERS_PATH, { ig_story_member: payload }),

  // Updates category, capacity, order, or active state for one configured member.
  updateMember: ({ id, payload }) => axios.put(`${MEMBERS_PATH}/${id}`, { ig_story_member: payload }),

  // Removes only feature membership; historical assignment rows remain untouched.
  deleteMember: ({ id }) => axios.delete(`${MEMBERS_PATH}/${id}`)
}

export default SalesIgStoryApi
